import { Link } from 'react-router-dom';
import { Activity, TrendingUp, Brain, Stethoscope, Heart, Baby, UserCheck, Home as HomeIcon } from 'lucide-react';
import { Card, CardContent } from '../components/ui/card';
import { Helmet } from 'react-helmet-async';
import './Services.css';

const Services = () => {
  const services = [
    {
      icon: <Activity size={48} />,
      title: 'Orthopaedic Physiotherapy',
      description: 'Specialized treatment for bone, joint, muscle, and ligament conditions. Expert care for arthritis, fractures, and musculoskeletal disorders.',
      link: '/services/orthopaedic'
    },
    {
      icon: <TrendingUp size={48} />,
      title: 'Sports Injury Rehabilitation',
      description: 'Get back to peak performance with our sports-specific rehabilitation programs. Treatment for sprains, strains, and athletic injuries.',
      link: '/services/sports-injury'
    },
    {
      icon: <Brain size={48} />,
      title: 'Neurological Physiotherapy',
      description: 'Specialized care for stroke, paralysis, Parkinson\'s, and other neurological conditions. Comprehensive rehabilitation programs.',
      link: '/services/neurological'
    },
    {
      icon: <Stethoscope size={48} />,
      title: 'Post-Surgical Rehabilitation',
      description: 'Comprehensive recovery programs after orthopedic, cardiac, or general surgery. Faster healing with expert guidance.',
      link: '/services/post-surgical'
    },
    {
      icon: <Heart size={48} />,
      title: 'Back & Neck Pain Treatment',
      description: 'Effective treatment for chronic and acute back pain, neck pain, spondylosis, and disc problems. Long-lasting relief.',
      link: '/services/back-neck-pain'
    },
    {
      icon: <Baby size={48} />,
      title: 'Paediatric Physiotherapy',
      description: 'Gentle, effective treatment for children with developmental delays, cerebral palsy, and other pediatric conditions.',
      link: '/services/paediatric'
    },
    {
      icon: <UserCheck size={48} />,
      title: 'Geriatric / Elderly Care Physiotherapy',
      description: 'Specialized care for seniors including balance training, fall prevention, and mobility improvement programs.',
      link: '/services/geriatric'
    },
    {
      icon: <HomeIcon size={48} />,
      title: 'Home Visit Physiotherapy',
      description: 'Expert physiotherapy at your doorstep anywhere in Goa. Convenient, professional treatment in the comfort of your home.',
      link: '/services/home-visit'
    }
  ];

  return (
    <div className="services-page">
      <Helmet>
        <title>Physiotherapy Services in Panjim | Dr. Manaz Physiotherapy Clinic Goa</title>
        <meta name="description" content="Comprehensive physiotherapy services in Panjim, Goa. Orthopaedic, sports injury, neurological, post-surgical rehab, and home visits. Best physiotherapy treatment in Goa." />
      </Helmet>

      <div className="page-hero">
        <div className="container">
          <h1>Our Physiotherapy Services</h1>
          <p className="page-subtitle">Comprehensive treatment for all your rehabilitation needs in Panjim, Goa</p>
        </div>
      </div>

      <section className="section">
        <div className="container">
          <div className="intro-text">
            <p>
              At Dr. Manaz's Physiotherapy & Rehabilitation Clinic, we offer a complete range of physiotherapy services to help you recover from injury, manage chronic conditions, and improve your quality of life. Our certified physiotherapists use the latest techniques and equipment to deliver personalized care.
            </p>
          </div>

          <div className="services-grid-page">
            {services.map((service, index) => (
              <Card key={index} className="service-card-page">
                <CardContent className="service-card-content-page">
                  <div className="service-icon-page">{service.icon}</div>
                  <h2>{service.title}</h2>
                  <p>{service.description}</p>
                  <Link to={service.link} className="btn-primary">
                    Learn More About This Service
                  </Link>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services;